var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uc-tabs"},[_c('div',{staticClass:"tabs"},[_vm._t("tabs",null,null,{ activeTab: _vm.activeTab, selectTab: _vm.selectTab, registerTab: _vm.registerTab })],2),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("content",null,{"activeTab":_vm.activeTab})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }